<template>
  <section class="supplier-detail-operation-tab">
    <article class="customer-detail-card customer-detail-card--accent-primary">
      <ExpenseFeeToolbar
        class="supplier-detail-operation-toolbar"
        :filter-options="filterOptions"
        :search-placeholder="text.detail.feesTab.toolbar.searchPlaceholder"
        inline-filter-key="expense_class"
        :first-row-keys="['category', 'tags']"
        :second-row-keys="['has_xml', 'currency']"
        :filter-configs="toolbarFilterConfigs"
        :all-option-labels="toolbarAllOptionLabels"
        :selection-all-labels="toolbarSelectionAllLabels"
        :empty-option-text="text.detail.feesTab.toolbar.emptyOption"
        :filters-button-title="text.detail.feesTab.toolbar.filtersButtonTitle"
        :search-button-title="text.detail.feesTab.toolbar.searchButtonTitle"
        :date-range-presets="toolbarDateRangePresets"
        initial-preset-key=""
        :first-row-columns="2"
        :second-row-columns="2"
        @search-change="$emit('search-change', $event)"
        @filters-change="$emit('filters-change', $event)"
      />

      <StatusTabs
        class="supplier-detail-operation-status-tabs"
        :tabs="statusTabs"
        :active-tab="activeStatusTab"
        @select="$emit('status-tab-select', $event)"
      />

      <SaleSharedFeesTable
        :rows="rows"
        :loading="loading"
        :empty-text="emptyText"
        :pagination="pagination"
        :show-business-column="true"
        :show-provider-column="false"
        @page-change="$emit('page-change', $event)"
        @pay-expense="$emit('pay-expense', $event)"
        @edit-expense="$emit('edit-expense', $event)"
        @delete-expense="$emit('delete-expense', $event)"
        @approve-expense="$emit('approve-expense', $event)"
        @download-xml="$emit('download-xml', $event)"
        @download-pdf="$emit('download-pdf', $event)"
        @download-receipt="$emit('download-receipt', $event)"
      />
    </article>
  </section>
</template>

<script>
import ExpenseFeeToolbar from '@/components/expensesFees/ExpenseFeeToolbar.vue';
import StatusTabs from '@/components/common/StatusTabs.vue';
import SaleSharedFeesTable from '@/components/sales/shared/fees/SaleSharedFeesTable.vue';
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('sales');

export default {
  name: 'SupplierDetailFeesTab',
  components: {
    ExpenseFeeToolbar,
    StatusTabs,
    SaleSharedFeesTable,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    filterOptions: {
      type: Object,
      default: () => ({}),
    },
    pagination: {
      type: Object,
      default: () => ({
        current_page: 1,
        per_page: 30,
        total_pages: 1,
        total_items: 0,
      }),
    },
    statusTabs: {
      type: Array,
      default: () => [],
    },
    activeStatusTab: {
      type: String,
      default: 'all',
    },
    emptyText: {
      type: String,
      default: text.detail.feesTab.table.empty,
    },
  },
  emits: [
    'search-change',
    'filters-change',
    'status-tab-select',
    'page-change',
    'pay-expense',
    'edit-expense',
    'delete-expense',
    'approve-expense',
    'download-xml',
    'download-pdf',
    'download-receipt',
  ],
  data() {
    return {
      text,
      toolbarDateRangePresets: text.detail.feesTab.toolbar.dateRangePresets,
      toolbarAllOptionLabels: text.detail.feesTab.toolbar.allOptionLabels,
      toolbarSelectionAllLabels: text.detail.feesTab.toolbar.selectionAllLabels,
      toolbarFilterConfigs: [
        {
          key: 'expense_class',
          label: text.detail.feesTab.toolbar.filters.expenseClass.label,
          placeholder: text.detail.feesTab.toolbar.filters.expenseClass.placeholder,
          searchable: text.detail.feesTab.toolbar.filters.expenseClass.searchable,
        },
        {
          key: 'category',
          label: text.detail.feesTab.toolbar.filters.category.label,
          placeholder: text.detail.feesTab.toolbar.filters.category.placeholder,
          searchable: text.detail.feesTab.toolbar.filters.category.searchable,
        },
        {
          key: 'tags',
          label: text.detail.feesTab.toolbar.filters.tags.label,
          placeholder: text.detail.feesTab.toolbar.filters.tags.placeholder,
          searchable: text.detail.feesTab.toolbar.filters.tags.searchable,
        },
        {
          key: 'has_xml',
          label: text.detail.feesTab.toolbar.filters.hasXml.label,
          placeholder: text.detail.feesTab.toolbar.filters.hasXml.placeholder,
          searchable: text.detail.feesTab.toolbar.filters.hasXml.searchable,
        },
        {
          key: 'currency',
          label: text.detail.feesTab.toolbar.filters.currency.label,
          placeholder: text.detail.feesTab.toolbar.filters.currency.placeholder,
          searchable: text.detail.feesTab.toolbar.filters.currency.searchable,
        },
      ],
    };
  },
};
</script>

<style scoped>
.supplier-detail-operation-tab {
  display: grid;
  gap: 12px;
}

.supplier-detail-operation-toolbar,
.supplier-detail-operation-status-tabs {
  margin: 0;
}

.supplier-detail-operation-status-tabs {
  margin-top: 10px;
}

.supplier-detail-operation-status-tabs :deep(.sales-status-tabs) {
  margin-top: 0;
}
</style>
